export default __webpack_public_path__ + "static/media/radio_check_on_ico.cd6d0339.svg";